import IMediaPageItemTag from "../../models/mediaPage/IMediaPageItemTag";
import { parseArrayResponse, parseStringResponse } from "../utils";

export default function convertMediapageTagsResponse(
    tagsResponse: any
): IMediaPageItemTag[] | undefined {
    const parsedTagsResponse = parseArrayResponse(tagsResponse);
    if (typeof parsedTagsResponse === "undefined") return undefined;

    let _tags: IMediaPageItemTag[] = [];
    parsedTagsResponse.forEach((parsedTag) => {
        const { name, codename } = parsedTag;

        const _id = parseStringResponse(codename);
        if (typeof _id === "undefined") return;

        const _displayName = parseStringResponse(name);
        if (typeof _displayName === "undefined") return;

        _tags.push({
            displayName: _displayName,
            id: _id,
        });
    });

    return _tags;
}
